import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { styled, css } from 'styled-components';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { getLightenedColor, getColorFromCssVar, isCssVar } from '@fabric-app/utils/color';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { Image } from '@fabric-app/ui/components/Image';
import Tooltip from '@fabric-app/ui/components/Tooltip';

const AvatarText = styled.div.withConfig({
  displayName: "Avatar__AvatarText",
  componentId: "sc-61e28833-0"
})([
  `text-transform:uppercase;font-size:0.6em;font-weight:600;color:inherit;position:relative;z-index:2;`
]);
const AvatarInner = styled.div.withConfig({
  displayName: "Avatar__AvatarInner",
  componentId: "sc-61e28833-1"
})([
  `position:absolute;inset:0;display:block;background:`,
  `;display:flex;align-items:center;justify-content:center;`
], cssVar["color-bg-tertiary"]);
const AvatarContainer = styled.span.withConfig({
  displayName: "Avatar__AvatarContainer",
  componentId: "sc-61e28833-2"
})([
  `border-radius:50%;position:relative;overflow:hidden;flex-shrink:0;background-color:inherit;display:block;`,
  ` `,
  ` `,
  ` `,
  ``
], ({ size = 17 }) => css([
  `width:`,
  `px;height:`,
  `px;font-size:`,
  `px;`,
  ``
], size, size, size, size < 32 && css([
  ``,
  `{display:none;}`
], AvatarSpinner)), ({ color = cssVar["color-bg-tertiary"] }) => {
  return css([
    ``,
    `{color:`,
    `;background-color:`,
    `;}`,
    `{color:`,
    `;}`
  ], AvatarInner, color, getLightenedColor(isCssVar(color) ? getColorFromCssVar(color) : color, 0.8), AvatarText, color);
}, ({ fixedBgColor: fixedColor }) => fixedColor && css([
  ``,
  `{background:`,
  `;}`
], AvatarInner, fixedColor), ({ state }) => {
  if (state === "offline") {
    return css([
      ``,
      `{opacity:0.3;}`
    ], AvatarInner);
  }
});
const AvatarImage = styled(Image).attrs((p) => {
  return {
    draggable: "false",
    ...p
  };
}).withConfig({
  displayName: "Avatar__AvatarImage",
  componentId: "sc-61e28833-3"
})([
  `width:100%;height:100%;object-fit:cover;`
]);
const AvatarSpinner = styled(Spinner).attrs({
  size: 16,
  thickness: 3
}).withConfig({
  displayName: "Avatar__AvatarSpinner",
  componentId: "sc-61e28833-4"
})([
  ``
]);
const Avatar = /* @__PURE__ */ forwardRef(({ tooltip, children, allowTooltipHover = false, tooltipPlacement, ...props }, ref) => {
  if (tooltip) {
    return /* @__PURE__ */ jsx(Tooltip, {
      label: tooltip,
      delay: 0,
      allowTooltipHover,
      placement: tooltipPlacement,
      children: /* @__PURE__ */ jsx(AvatarContainer, {
        "data-color": props.color,
        ref,
        ...props,
        children: /* @__PURE__ */ jsx(AvatarInner, {
          children
        })
      })
    });
  }
  return /* @__PURE__ */ jsx(AvatarContainer, {
    ref,
    ...props,
    children: /* @__PURE__ */ jsx(AvatarInner, {
      children
    })
  });
});
Avatar.displayName = "Avatar";
const Avatar$1 = Object.assign(Avatar, {
  Container: AvatarContainer,
  Image: AvatarImage,
  Text: AvatarText,
  Spinner: AvatarSpinner
});

export { Avatar$1 as default };
//# sourceMappingURL=Avatar.js.map
